module.exports = __webpack_public_path__ + "media/images/logo-outline-white-61625dcc7491adced739ca5b285eff73.svg";